export default "__VITE_ASSET__Bb2RnIkr__"